import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useField, useFormikContext } from "formik";
import { FormLabel } from "./InputField";

export default function FormRadioGroup({
  required = false,
  options,
  name,
  label,
  fullWidth,
  disabled,
  commonProps = {},
  ...rest
}) {
  const [field, meta] = useField(name);
  const { value, ...other } = field;
  const formikContext = useFormikContext();
  // const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  return (
    <>
      <div
        className={
          "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
        }
        style={fullWidth ? { gridColumn: "span 2" } : {}}
      >
        <div className="nps-form-label">
          {label}
          {required && "*"}
        </div>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="Search"
            name="search"
            style={{ flexDirection: "row" }}
            value={value}
            {...other}
            {...rest}
          >
            {options.map((_option) => {
              const optionValue = String(_option.value);
              return (
                <div
                  key={optionValue}
                  className={`investor-radio-button input-margin dual-margin ${
                    value === optionValue ? "investor-active" : ""
                  }`}
                >
                  <FormControlLabel
                    label={_option.label}
                    value={optionValue}
                    disabled={disabled}
                    control={
                      <Radio
                        disabled={disabled}
                        className="investor-search-radio"
                        style={{ color: "#033f7c" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </FormControl>
        <div className="nps-error-message">{errorMessage}</div>
      </div>
    </>
  );
}
